import { useState, useEffect, useLayoutEffect } from 'react';
import { FolderViewOutlined, InboxOutlined, QuestionCircleOutlined, ProjectOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { Card, Skeleton, Switch, Row, Col, Button, Modal, Form, Tooltip } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { NavLink, useNavigate } from "react-router-dom";
import axios from 'axios';
import ReactQuill from 'react-quill';

const { Meta } = Card;


const Dashboard = () => {

  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [subDepartmentData, setSubDepartmentData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [notificationData, setNotificationData] = useState([]);
  const [form] = Form.useForm();
  const [userUuid, setUserUuid] = useState();
  const [userRole, setUserRole] = useState();
  const [popular, setPopular] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = useState();

  useEffect(() => {
    const userString = sessionStorage.getItem("user");
    const popSession = sessionStorage.getItem("kbs");
    const popValue = JSON.parse(popSession)
    const value = JSON.parse(userString)
    if (!userString) {
      navigate('/login')
    } else {

      axios
        .post(`${process.env.REACT_APP_API_URL}/popular`, { uuids: popValue })
        .then(response => {
          setPopular(response.data.products)
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function () {
            setError();
          }, 3000);
        });
      setUserUuid(value.uuid)
      setUserRole(value.role)
    }

  }, [])




  useEffect(() => {
    fetchMenuData();
  }, []);

  const fetchMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/departments`)
      .then(response => {
        const modifiedResponse = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setDepartmentData(modifiedResponse);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function () {
          setError();
        }, 3000);
      });

    axios
      .get(`${process.env.REACT_APP_API_URL}/sub_departments`)
      .then(response => {
        const modifiedResponseSub = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setSubDepartmentData(modifiedResponseSub);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function () {
          setError();
        }, 3000);
      });

    axios
      .get(`${process.env.REACT_APP_API_URL}/category`)
      .then(response => {
        const modifiedResponse = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setCategoryData(modifiedResponse);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function () {
          setError();
        }, 3000);
      });


    axios
      .get(`${process.env.REACT_APP_API_URL}/sub_category`)
      .then(response => {
        const modifiedResponseSub = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setSubCategoryData(modifiedResponseSub);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function () {
          setError();
        }, 3000);
      });


    axios
      .get(`${process.env.REACT_APP_API_URL}/users`)
      .then(response => {
        const modifiedResponse = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setUsersData(modifiedResponse);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function () {
          setError();
        }, 3000);
      });


    axios
      .get(`${process.env.REACT_APP_API_URL}/menu`)
      .then(response => {
        const modifiedResponseSub = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setMenuData(modifiedResponseSub);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function () {
          setError();
        }, 3000);
      });



    axios
      .get(`${process.env.REACT_APP_API_URL}/notifications`)
      .then(response => {
        const modifiedResponseSub = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setNotificationData(modifiedResponseSub);
        setLoading(false);

      })
      .catch(error => {
        console.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function () {
          setError();
        }, 3000);
      });


  };


  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setLoading(true);

  };
  const handleCancel = () => {
    setOpen(false);
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };


  const onFinish = async (values) => {

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/notifications`, values, {
        headers: { 'Content-Type': 'application/json' },
      });
       
      fetchMenuData();
      setTimeout(() => {
        setLoading(false);
        setOpen(false);
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {

    if(userRole){
      if (userRole == 'admin') {
        axios
          .get(`${process.env.REACT_APP_API_URL}/products`)
          .then(response => {
            const modifiedResponseSub = response.data.map(item => ({
              ...item,
              key: item.uuid,
            }));
            setProductData(modifiedResponseSub);
          })
          .catch(error => {
            console.error(error.response.data.msg);
            // message.error(error.response.data.msg);
            setError(error.response.data.msg);
            setTimeout(function () {
              setError();
            }, 3000);
          });
      } else {
  
        axios
          .get(`${process.env.REACT_APP_API_URL}/productsByUser/${userUuid}`)
          .then(response => {
            const modifiedResponseSub = response.data.map(item => ({
              ...item,
              key: item.uuid,
            }));
            setProductData(modifiedResponseSub);
          })
          .catch(error => {
            console.error(error.response.data.msg);
            // message.error(error.response.data.msg);
            setError(error.response.data.msg);
            setTimeout(function () {
              setError();
            }, 3000);
          });
      }
    }
  }, [loading])

console.log(productData)
  return (
    <div className="dashboardWrapper">
      {error && <div className='errorApi'>{error}</div>}
      {userRole == 'admin' ? <div className="cardsWrapper">
        <NavLink to={"/department_master"}>
          <Card
            style={{
              width: 232,
              marginTop: 16,
            }}
            actions={[
              <Tooltip title="visit departments">
                <NavLink to={"/department_master"}><FolderViewOutlined key="View Detail" /></NavLink>
              </Tooltip>
            ]}
          >

            <Skeleton loading={loading} avatar active>

              <Meta
                avatar={<InboxOutlined />}
                title={departmentData.length ? departmentData.length : '0'}
                description="Departments"
              />

            </Skeleton>

          </Card>
        </NavLink>
        <NavLink to={"/users"}>
          <Card
            style={{
              width: 232,
              marginTop: 16,
            }}
            actions={[
              <Tooltip title="visit users">
                <NavLink to={"/users"}><FolderViewOutlined key="View Detail" /></NavLink>
              </Tooltip>
            ]}
          >
            <Skeleton loading={loading} avatar active>
              <Meta
                avatar={<UserSwitchOutlined />}
                title={usersData.length ? usersData.length : '0'}
                description="KBS Users"
              />
            </Skeleton>
          </Card>
        </NavLink>
        <NavLink to={"/department_master"}>
          <Card
            style={{
              width: 232,
              marginTop: 16,
            }}
            actions={[
              <Tooltip title="visit sub-departments">
                <NavLink to={"/department_master"}><FolderViewOutlined key="View Detail" /></NavLink>
              </Tooltip>
            ]}
          >
            <Skeleton loading={loading} avatar active>
              <Meta
                avatar={<InboxOutlined />}
                title={subDepartmentData.length ? subDepartmentData.length : '0'}
                description="Sub Departments"
              />
            </Skeleton>
          </Card>
        </NavLink>
        <NavLink to={"/category_master"}>
          <Card
            style={{
              width: 232,
              marginTop: 16,
            }}
            actions={[
              <Tooltip title="visit categories">
                <NavLink to={"/category_master"}><FolderViewOutlined key="View Detail" /></NavLink>
              </Tooltip>
            ]}
          >
            <Skeleton loading={loading} avatar active>
              <Meta
                avatar={<InboxOutlined />}
                title={categoryData.length ? categoryData.length : '0'}
                description="Categories"
              />
            </Skeleton>
          </Card>
        </NavLink>
        <NavLink to={"/category_master"}>
          <Card
            style={{
              width: 232,
              marginTop: 16,
            }}
            actions={[
              <Tooltip title="visit sub-categories">
                <NavLink to={"/category_master"}><FolderViewOutlined key="View Detail" /></NavLink>
              </Tooltip>
            ]}
          >
            <Skeleton loading={loading} avatar active>
              <Meta
                avatar={<InboxOutlined />}
                title={subCategoryData.length ? subCategoryData.length : '0'}
                description="Sub Categories"
              />
            </Skeleton>
          </Card>
        </NavLink>
        <NavLink to={"/menu"}>
          <Card
            style={{
              width: 232,
              marginTop: 16,
            }}
            actions={[
              <Tooltip title="visit menu items">
                <NavLink to={"/menu"}><FolderViewOutlined key="View Detail" /></NavLink>
              </Tooltip>
            ]}
          >
            <Skeleton loading={loading} avatar active>
              <Meta
                avatar={<InboxOutlined />}
                title={menuData.length ? menuData.length : '0'}
                description="Menu Items"
              />
            </Skeleton>
          </Card>
        </NavLink>

      </div> : <><div className="cardsWrapper">
        {
          menuData.map((item) => {
            if (item.type === 'item' && item.uuid) {


              return (
                <div key={item.uuid} className=''>
                  <NavLink to={`/product_menu/?mEnc=${item.uuid}`}>
                    <Card
                      style={{
                        width: 232,
                        marginTop: 16,
                      }}
                      actions={[
                        <NavLink to={`/product_menu/?mEnc=${item.uuid}`}><FolderViewOutlined key="View Detail" /></NavLink>
                      ]}
                    >
                      <Skeleton loading={loading} avatar active>
                        <Meta
                          avatar={<InboxOutlined />}
                          title={item.name}
                        //  description={item.name}
                        />
                      </Skeleton>
                    </Card>
                  </NavLink>

                </div>
              );
            } else {

            }
          })
        }



      </div>
        {
          popular ? <div className="popularArt">
            <h3>Recently Browsed Documents</h3>
            <div className='holderPopular'>
              {popular.map((item) => {

                return (
                  <div >
                    <div key={item.uuid} className=''>
                      <NavLink to={`/product_view/?reqU=${item.uuid}`}>
                        <Card
                          style={{
                            width: 232,
                            marginTop: 16,
                          }}
                          actions={[
                            <NavLink to={`/product_view/?reqU=${item.uuid}`}><FolderViewOutlined key="View Detail" /></NavLink>
                          ]}
                        >
                          <Skeleton loading={loading} avatar active>
                            <Meta
                              avatar={<InboxOutlined />}
                              title={item.title}
                            //  description={item.name}
                            />
                          </Skeleton>
                        </Card>

                      </NavLink>
                    </div>
                  </div>
                );

              })}
            </div>

          </div> : null
        }</>}

      <div className='updatesNotification_wrapper'>
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
        >
          <Col className="gutter-row" span={10} >
            <Skeleton loading={loading} active>
              {userRole == 'admin' ? <div className='updatesWrapper'>
                <div className='title'>Recently Added Documents... </div>
                <ul>
                  {productData.map((data) => (
                    <li key={data.uuid}><Tooltip title={`Click to visit knowledge: ${data.title}`}><NavLink to={`/product_view?reqU=${data.uuid}`}>New knowledge: <em>{data.title}</em> has been published by admin at <em>{data.createdAt}</em></NavLink></Tooltip></li>
                  ))}
                </ul>
              </div> : <div className='updatesWrapper'>
                <div className='title'>Recently Added Documents... </div>
                <ul>
                  {productData.map((data) => (
                    <li key={data.uuid}><Tooltip title={`Click to visit knowledge: ${data.title}`}><NavLink to={`/product_view?reqU=${data.uuid}`}>New knowledge: <em>{data.title}</em> has been published by admin at <em>{data.createdAt}</em></NavLink></Tooltip></li>
                  ))}
                </ul>
              </div>}
            </Skeleton>
            <Modal
              open={open}
              title="Add Notification"
              onOk={handleOk}
              onCancel={handleCancel}
              footer={[
                <Button key="back" onClick={handleCancel}>
                  Return
                </Button>,
                <Button key='submit' type='primary' htmlType="submit" form='notificationForm'>
                  Submit
                </Button>,
              ]}
            >
              <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                id="notificationForm"
              >
                <Form.Item label='' name='notification' rules={[{ required: true, message: 'Please add notifications first ...' }]}>
                  <ReactQuill style={{ overflow: 'hidden' }} />
                </Form.Item>
              </Form>
            </Modal>
          </Col>
          <Col span={10} className="gutter-row">
            <Skeleton loading={loading} active>
              <div className='newsWrapper'>
                <div className='title'>News And Notifications {userRole == 'admin' ? <Tooltip title="Adding new notification will be visible to all the users and admins!"><Button onClick={showModal}>
                  Add Notification
                </Button> </Tooltip> : null}</div>
                <ul>
                  {notificationData.map((data) => (
                    <li key={data.uuid} dangerouslySetInnerHTML={{ __html: data.notification + `Created at: ${data.createdAt}` }} />
                  ))}
                </ul>
              </div>
            </Skeleton>
          </Col>
          {userRole == 'admin' ? <Col span={4} className="gutter-row">
            <Skeleton loading={loading} active>
              <div className='shortWrapper'>
                <div className='title'>Shortcut Links</div>
                <div className='shortBtn-list'>
                  <Button type="dashed" onClick={() => { navigate('/product?prMod=true') }}>Add Product</Button>
                  <Button type="dashed" onClick={() => { navigate('/users?add=true') }}>Add Users</Button>
                  <Button type="dashed" onClick={() => { navigate('/department_master?add=true') }}>Add Department</Button>
                  <Button type="dashed" onClick={() => { navigate('/department_master?add=true&sub=1') }}>Add Sub-Department</Button>
                  <Button type="dashed" onClick={() => { navigate('/category_master?add=true') }}>Add Category</Button>
                  <Button type="dashed" onClick={() => { navigate('/category_master?add=true&sub=1') }}>Add Sub-Category</Button>
                </div>
              </div>
            </Skeleton>
          </Col> : null}
        </Row>
      </div>
    </div>
  )
}

export default Dashboard